import React from 'react';
import ATable from '../../common/table';

const DisputeRegionsTable = (props) => {
    
 
    const columns = [{
        header: "S/N",
        width: 50,
        render :  row => (<div>{props.paginatedCallBack(row.viewIndex)}</div>)
    }, 
    {
        header: "Type",
        accessor: "type"
    },
    {
        header: "Code",
        accessor: "code",
    },
    {
        header: "Description",
        accessor: "description",
    },
    {
        header: "Settings Value",
        accessor: "settingsValue",
    },
    {
        header: "Extra Info",
        accessor: "extraInfo",
    },
    {
        header: "Enabled",
        accessor: "enabled",
    },
    {
        header: "Auditable Id",
        accessor: "auditableId",
    },
    {
        header: "Auditable Name",
        accessor: "auditableName",
    }
    ];
    return (
   

            <ATable
                className="-striped -highlight"
                    tableData={props.settingsConfig}
                    columns={columns}
                    onChange={props.onTableChange || null}     
                    manual
                    {...props} />
    )
};

export default DisputeRegionsTable;


// WEBPACK FOOTER //
// ./src/components/admin/settingsConfig/settingsConfigTable.js